import React, { useEffect, useState } from 'react'

// components
import { useRouter } from 'next/router'
import Link from 'next/link'

// utilies

// resources
import ArrowRightIcon from 'assets/icons/arrow-right-line.svg?component'

// styles
import styles from './index.module.scss'
import { getFirstUpperString } from 'utils/helpers'
import { getDisplayUserName } from 'utils/strings'

const NFTDetailSection = props => {
  const {
    nftOwnerUsername,
    nftType,
    nftCoverUrl,
    editionType,
    editionDetail,
    supply,
    isNftMasterEdition,
    isNftPrintEdition,
    royalties,
  } = props
  const router = useRouter()
  const [dimensions, setDimensions] = useState(null)

  useEffect(() => {
    if (nftType.includes('image')) {
      const img = new window.Image()
      img.src = nftCoverUrl
      img.onload = () => {
        setDimensions({ width: img.width, height: img.height })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftCoverUrl])

  const getType = type => {
    if (type.includes('/')) {
      let main_type = type.slice(0, type.indexOf('/'))
      let sub_type = type.slice(type.indexOf('/') + 1, type.length)
      return getFirstUpperString(main_type) + ' (' + sub_type.toUpperCase() + ')'
    } else {
      return getFirstUpperString(type)
    }
  }

  return (
    <div className="w-full mt-[15px]">
      <div className={styles.details}>Details</div>
      <div className={styles.border} />

      <div className="w-full ">
        <div>
          <div className="w-full flex justify-between items-center mt-[15px]">
            <div className={styles.label}>Medium</div>
            <div className={styles.value}>{getType(nftType)}</div>
          </div>
          {dimensions && (
            <div className="w-full flex justify-between items-center mt-[6px]">
              <div className={styles.label}>Dimensions</div>
              <div className={styles.value}>
                {dimensions.width}px by {dimensions.height}px
              </div>
            </div>
          )}
        </div>

        <div className="w-full flex justify-between items-center mt-[6px]">
          <div className={styles.label}>Royalties</div>
          <div className={styles.value}>{royalties}%</div>
        </div>

        <div className="w-full flex justify-between items-center mt-[6px]">
          <div className={styles.label}>Owner</div>
          <Link href={`/${nftOwnerUsername}`} passHref>
            <a>
              <div className={styles.username}>{getDisplayUserName(nftOwnerUsername)}</div>
            </a>
          </Link>
        </div>

        {editionDetail && isNftPrintEdition && (
          <div
            className={styles.masterEdition}
            onClick={() => {
              router.push(`/nft/${supply.parent}`)
            }}
          >
            <div className={styles.label}>Master Edition</div>
            <ArrowRightIcon />
          </div>
        )}
      </div>
    </div>
  )
}

export default NFTDetailSection
